// Check for member session
import Cookies from "js-cookie";
import { LONGNOW_API_DOMAIN } from "./env";

let member = null;
const setMember = () => {
  const member = {
    username: localStorage.getItem("username"),
    full_name: localStorage.getItem("full_name"),
    email: localStorage.getItem("email"),
    membership_number: parseInt(
      localStorage.getItem("membership_number")
    ).toLocaleString("en-US"),
  };
  return member;
};

if (Cookies.get("lnu")) {
  // LNU? Check for member info in localStorage and fetch it if necessary then setMember
  if (!localStorage.getItem("membership_number")) {
    const response = await fetch(`${LONGNOW_API_DOMAIN}/api/v1/membership/me`);
    const data = await response.json();
    if (data) {
      localStorage.setItem("full_name", data.first_name + " " + data.last_name);
      localStorage.setItem("email", data.email);
      localStorage.setItem("membership_number", data.membership_number);
    }
  }
  member = setMember();
} else {
  // No LNU? Clear localStorage and leave member null
  if (localStorage.getItem("username")) {
    localStorage.clear();
  }
}
export default member;
